import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Section from "components/section";
import {
  Typography,
  TableContainer,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Grid,
  Link,
  TextField,
} from "@material-ui/core";
import { Delete, Edit, Visibility } from "@material-ui/icons";
import { toast } from "react-toastify";

// Navigation
import NavCrumbs from "./clients-all-clients-nav-crumbs";

//InstantSearch
import { getSearchClient } from "utils/algolia";
import {
  InstantSearch,
  connectSearchBox,
  connectHits,
  connectPagination,
  RefinementList,
  Stats
} from "react-instantsearch-dom";

// Styles
import styles from "routes/dashboard/dashboard-styles";
const useStyles = makeStyles(styles);

const searchClient = getSearchClient();

export default function (props) {
  const classes = useStyles();
  const {
    loading,
    toggleAddClientForm,
    onPressedItem,
    clients,
    onPressedDeleteItem,
    sectionDescription,
    user,
    refreshAlgolia,
    setRefreshAlgolia
  } = props;

  React.useEffect(()=>{
    searchClient.clearCache();
  },[])
 
  const Pagination = ({ currentRefinement, nbPages, refine, createURL }) => (
    <Grid container spacing={3}>
      <Grid item xs={2}></Grid>

      <Grid item xs={8} className={classes.pagination}>
        <ul className={classes.paginationList}>
          {currentRefinement > 1 && (
            <li className={classes.paginationListItem}>
              <Link
                href={createURL(currentRefinement - 1)}
                onClick={(event) => {
                  event.preventDefault();
                  refine(currentRefinement - 1);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                >
                  <g
                    fill="none"
                    fillRule="evenodd"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.143"
                  >
                    <path d="M9 5H1M5 9L1 5l4-4" />
                  </g>
                </svg>
              </Link>
            </li>
          )}
          {new Array(nbPages).fill(null).map((_, index) => {
            const page = index + 1;
            return (
              <li
                key={index}
                className={
                  currentRefinement === page
                    ? classes.paginationListItemActive
                    : classes.paginationListItem
                }
              >
                <Link
                  href={createURL(page)}
                  onClick={(event) => {
                    event.preventDefault();
                    refine(page);
                  }}
                >
                  {page}
                </Link>
              </li>
            );
          })}
          {nbPages > 1 && currentRefinement < nbPages && (
            <li className={classes.paginationListItem}>
              <Link
                href={createURL(currentRefinement + 1)}
                onClick={(event) => {
                  event.preventDefault();
                  refine(currentRefinement + 1);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                >
                  <g
                    fill="none"
                    fillRule="evenodd"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.143"
                  >
                    <path d="M1 5h8M5 9l4-4-4-4" />
                  </g>
                </svg>
              </Link>
            </li>
          )}
        </ul>
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
  const CustomPagination = connectPagination(Pagination);

  const SearchBox = ({ currentRefinement, refine }) => {
    return (
      <TextField
        type="search"
        variant="outlined"
        label="Search for a client"
        value={currentRefinement}
        fullWidth
        onChange={(event) => refine(event.currentTarget.value)}
        className={classes.searchBar}
      />
    );
  };

  const CustomSearchBox = connectSearchBox(SearchBox);

  const Hits = ({ hits, refineNext }) => {
    return (
      <TableBody>
        {hits.map((row, index) => {
            return (
              <TableRow hover key={row.objectID} className={classes.row}>
                <TableCell
                  onClick={(event) => onPressedItem(row.objectID)}
                  className={classes.cellType}
                  align="left"
                >
                  {row.title}
                </TableCell>
                <TableCell
                  onClick={(event) => onPressedItem(row.objectID)}
                  className={classes.cellType}
                  align="left"
                >
                  {row.vacancies.length}
                </TableCell>
                <TableCell
                  onClick={(event) => onPressedItem(row.objectID)}
                  className={classes.cellType}
                  align="left"
                >
                  {row.industry}
                </TableCell>
              
               
                <TableCell className={classes.selectRight} align="right">
                  
                  <IconButton
                    aria-label="delete"
                    color="primary"
                    onClick={(event) => {
                      if(row.vacancies.length>0){
                        toast.error("Delete client's vacancies before deleting client");
                      }else{
                        onPressedDeleteItem(row.objectID);
                      }
                    }}
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
        })}
      </TableBody>
    );
  };

  const CustomHits = connectHits(Hits);

  React.useEffect(()=>{
    searchClient.clearCache();
  },[])


  return (
    <NavCrumbs>
      <Section
        title="RESOURCING CLIENTS"
        loading={loading}
        // actionName="Add Client"
        // handleAction={toggleAddClientForm}
        sectionDescription={sectionDescription}
      >
        {clients.length > 0 && (
          <InstantSearch indexName="Clients" searchClient={searchClient}  refresh={refreshAlgolia}>
             <Stats
              translations={{
                stats(
                  nbHits,
                  processingTimeMS,
                  nbSortedHits,
                  areHitsSorted
                ) {
                  return (
                    <Typography className={classes.stat}>
                      {nbHits} Clients in {processingTimeMS} ms
                    </Typography>
                  );
                },
              }}
            />
            <RefinementList
              attribute="businessLines"
              operator="or"
              defaultRefinement={"Resourcing"}
            />
            <CustomSearchBox />
            <TableContainer component={Paper}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">
                      {" "}
                      <Typography className={classes.labelText}>
                        Title
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      {" "}
                      <Typography className={classes.labelText}>
                        Vacancies
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      {" "}
                      <Typography className={classes.labelText}>
                        Industry
                      </Typography>
                    </TableCell>
                    <TableCell align="right"></TableCell>
                  </TableRow>
                </TableHead>
                <CustomHits />
              </Table>
            </TableContainer>
            <CustomPagination />
          </InstantSearch>
        )}
        {clients.length === 0 && (
          <Typography className={classes.emptyText} align="center">
            You haven't created any clients yet.
          </Typography>
        )}
      </Section>
    </NavCrumbs>
  );
}
